<template>
  <b-form
    @submit.prevent="submit(false)"
    @reset.prevent="reset"
    :novalidate=true>
    <div v-if="hasAllFields">
        <b-row>
        <b-col>
          <b-form-group
            label="Project Name"
            label-for="project-name"
            invalid-feedback="Please give project a name">
            <b-form-input
              id="project-name"
              v-model="form.name"
              required
              autofocus
              :disabled="disableEdit"
              maxlength="100"
              :state="errors.length == 0 ? null : form.name === '' ? false : mode === 'Add' ? true : null">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="District"
            label-for="project-district"
            invalid-feedback="Please enter district">
            <b-form-select id="project-district"
              v-model="form.district"
              :disabled="disableEdit">
              <option value></option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Start Date"
            label-for="project-startdate"
            invalid-feedback="Please enter start date">
            <b-form-datepicker
              id="project-startdate"
              v-model="form.startDate"
              required
              :disabled="disableEdit"
              :state="errors.length == 0 ? null : form.startDate === '' ? false : mode === 'Add' ? true : null"
              size="sm"
              placeholder="mm/dd/yyyy"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="End Date"
            label-for="project-enddate"
            invalid-feedback="Please enter end date">
            <b-form-datepicker
              id="project-enddate"
              v-model="form.endDate"
              :disabled="disableEdit"
              size="sm"
              placeholder="mm/dd/yyyy"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Preset Tags"
            label-for="project-tags">
            <b-form-tags
              id="project-tags"
              v-model.trim="form.presetTags"
              separator=","
              :disabled="disableEdit">
            </b-form-tags>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Day to send Evaluation"
              label-for="project-send-survey-day">
              <b-form-select
                id="project-send-survey-day"
                v-model="form.sendSurveyDay"
                :disabled="disableEdit">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
              </b-form-select>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Project Budget"
            label-for="project-cost"
            invalid-feedback="Project cost must be a number">
            <b-form-input
              id="project-cost"
              v-model="form.projectCost"
              :disabled="disableEdit"
              :state="errors.length == 0 ? null : projectCostState">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="EA/Contract #"
            label-for="project-identifier">
            <b-form-input
              id="project-identifier"
              v-model="form.projectIdentifier"
              maxlength="50"
              :disabled="disableEdit">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="mode === 'Edit'">
        <b-row>
          <b-col>
            <b-form-group label="Partnering Cost"
              label-for="project-partnering-cost"
              invalid-feedback="Parterning cost must be a number">
              <b-form-input
                id="project-partnering-cost"
                v-model="form.partneringCost"
                :disabled="disableEdit"
                :state="errors.length == 0 ? null : partneringCostState">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Upload Charter"
              label-for="project-charter">
              <b-form-file id="project-charter"
                v-model="form.charter"
                :disabled="disableEdit" >
                <template slot="file-name" slot-scope=" { names }">
                  <b-badge variant="dark">{{names[0]}}</b-badge>
                  <!-- <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                      + {{names.length - 1}} More files
                  </b-badge>-->
                </template>
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Status"
              label-for="project-status">
              <b-form-select
                id="project-status"
                v-model="form.status"
                :disabled="disableEdit">
                <option value="Open">Open</option>
                <option value="Closed">Closed</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <!-- <b-form-group
              label="Day to send Evaluation"
              label-for="project-send-survey-day">
              <b-form-select
                id="project-send-survey-day"
                v-model="form.sendSurveyDay"
                :disabled="disableEdit">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </b-form-select>
            </b-form-group> -->
          </b-col>
        </b-row>
      </div>
    </div>
    <b-form-group
      label="Owner"
      label-for="project-owner"
      v-if="hasAllFields || hasField('project-owner')">
      <b-input-group>
        <b-form-select
          id="project-owner"
          v-model="form.owner"
          aria-describedby="ownerInvalidFeeback"
          required
          :options="ownerOptions"
          @change="onOwnerChange"
          :disabled="disableEdit"
          :state="errors.length == 0 ? null : (form.owner === '' || form.owner.organizationId === '') ? false : mode === 'Add' ? true : null">
        </b-form-select>
        <b-input-group-append v-if="form.owner.organizationId === '' && !disableEdit">
          <b-button v-on:click="addOwner">New</b-button>
        </b-input-group-append>
        <b-form-invalid-feedback id="ownerInvalidFeedback">
          Please choose an Owner
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
    <b-form-group
      v-if="hasAllFields || hasField('project-contractor')"
      label="Contractor"
      label-for="project-contractor">
      <b-input-group>
        <b-form-select
          id="project-contractor"
          v-model="form.contractor"
          aria-describedby="contractorInvalidFeedback"
          required
          :options="contractorOptions"
          @change="onContractorChange"
          :disabled="disableEdit"
          :state="errors.length == 0 ? null : (form.contractor === '' || form.contractor.organizationId === '') ? false : mode === 'Add' ? true : null">
        </b-form-select>
        <b-input-group-append v-if="form.contractor.organizationId === '' && !disableEdit">
          <b-button v-on:click="addContractor">New</b-button>
        </b-input-group-append>
        <b-form-invalid-feedback id="contractorInvalidFeedback">
          Please choose a Contractor
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
    <b-row>
      <b-col v-if="hasAllFields || hasField('project-re')">
        <b-spinner v-if="loadingOwnerUsers" style="margin-left: 110px;"></b-spinner>
        <b-form-group
          v-else
          label="Resident Engineer"
          label-for="project-re">
          <b-input-group>
            <b-form-select
              id="project-re"
              v-model="form.primaryOwner"
              required
              aria-describedby="reInvalidFeedback"
              :options="ownerUserValidOptions"
              :disabled="disableEdit"
              :state="errors.length == 0 ? null : (form.primaryOwner === '' || form.primaryOwner.id === '') ? false : mode === 'Add' ? true : null">
            </b-form-select>
            <b-input-group-append v-if="form.primaryOwner.id === '' && 
              !disableEdit">
              <b-button v-on:click="addPrimaryOwner">New</b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="reInvalidFeedback">
              Please choose a Resident Engineer
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col v-if="hasAllFields || hasField('project-pm')">
        <b-spinner v-if="loadingContractorUsers" style="margin-left: 110px;"></b-spinner>
        <b-form-group
          v-else
          label="Project Manager"
          label-for="project-pm"
          invalid-feedback="Please choose a Project Manager">
          <b-input-group>
            <b-form-select
              id="project-pm"
              v-model="form.primaryContractor"
              required
              aria-describedby="pmInvalidFeedback"
              :options="contractorUserValidOptions"
              :disabled="disableEdit"
              :state="errors.length == 0 ? null : (form.primaryContractor === '' || form.primaryContractor.id === '') ? false : mode === 'Add' ? true : null">
            </b-form-select>
            <b-input-group-append v-if="form.primaryContractor.id === '' && 
              !disableEdit">
              <b-button v-on:click="addPrimaryContractor">New</b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="pmInvalidFeedback">
              Please choose a Project Manager
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!disableEdit">
      <b-col>
        <b-button type="submit" variant="primary" class="float-right ml-2" style="padding: .375rem .75rem">
          <b-spinner v-if="sending" small label="Spinning"></b-spinner>
          <div v-else>
            {{ mode === "Edit" ? "Update" : "Create" }}
          </div>
        </b-button>
        <b-button 
          v-if="hasAllFields" 
          type="reset" 
          class="float-right"
        >Cancel</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      </b-col>
    </b-row>
    <AddOrganizationModal
      ref="new-organization-modal"
      :organizations="organizations"
      @add="addOrganizationSubmit">
    </AddOrganizationModal>
    <EditUserModal
      ref="new-user-modal"
      :mode="'Create'"
      :userEmails="userEmails"
      @create="addUserSubmit">
    </EditUserModal>
    <BaseConfirmationModal
      ref="update-confirmation-modal"
      :title="'Update Confirmation'"
      @submit="submit(true)"
    ></BaseConfirmationModal>
  </b-form>
</template>

<script>
import axios from "axios";
import AddOrganizationModal from "@/modal-components/AddOrganizationModal.vue";
import EditUserModal from "@/modal-components/EditUserModal.vue";
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";

export default {
  props: {
    mode: { type: String, default: "Edit" },
    project: { type: Object, default: null },
    fields: { type: Array, default: () => { return []; } }
  },
  components: {
    AddOrganizationModal,
    BaseConfirmationModal,
    EditUserModal
  },
  data() {
    return {
      errors: [],
      loadingOrgs: false,
      loadingOwnerUsers: false,
      loadingContractorUsers: false,
      sending: false,
      addingOrganization: "",
      addingUser: "",
      addedNewOwner: false,
      addedNewContractor: false,
      addedNewPrimaryOwner: false,
      addedNewPrimaryContractor: false,
      disableEdit: false,
      organizations: [],
      orgOptions: [{ value: this.newOrganization(), text: "" }],
      contractorUserOptions: [{ value: this.newUser(), text: "" }],
      ownerUserOptions: [{ value: this.newUser(), text: "" }],
      form: this.project ? this.buildProject(this.project) : this.newForm()
    }
  },
  mounted() {
    this.loadOrganizations();
    this.disableEdit = this.mode === 'Edit' && this.isSystemAdmin === false;
  },
  methods: {
    submit(confirmed) {
      this.errors = [];
      if (!this.validateProject(this.form)) {
        return;
      }

      if (this.mode === "Edit") {
        if (confirmed) {
          this.updateProject();
        } else {
          this.$refs['update-confirmation-modal'].show();
        }
      } else {
        this.addProject();
      }
    },
    reset() {
      this.$emit('reset');
    },
    resetForm() {
      this.errors = [];
      this.addingOrganization = "";
      this.addingUser = "";
      this.addedNewOwner = false,
      this.addedNewContractor = false,
      this.addedNewPrimaryOwner = false,
      this.addedNewPrimaryContractor = false,
      this.form = this.newForm();
      this.contractorUserOptions = [{ value: this.newUser(), text: "" }];
      this.ownerUserOptions = [{ value: this.newUser(), text: "" }];
    },
    buildRequest(form) {
      let request =  {
        projectId: this.project ? this.project.projectId : this.$helpers.generateUUID(),
        projectName: form.name,
        category: form.district,
        startDate: form.startDate,
        endDate: form.endDate,
        projectCost: form.projectCost,
        partneringCost: form.partneringCost,
        projectIdentifier: form.projectIdentifier,
        status: form.status,
        onTime: this.project ? this.project.onTime : false,
        withinBudget: this.project ? this.project.withinBudget : false,
        totalClaims: this.project ? this.project.totalClaims : null,
        owner: {
          organizationId: form.owner.organizationId,
          name: form.owner.name
        },
        contractor: {
          organizationId: form.contractor.organizationId,
          name: form.contractor.name
        },
        primaryOwner: {
          userId: form.primaryOwner.id,
          name: form.primaryOwner.name,
          jobTitle: form.primaryOwner.jobTitle,
          email: form.primaryOwner.email,
          phone: form.primaryOwner.phone
        },
        primaryContractor: {
          userId: form.primaryContractor.id,
          name: form.primaryContractor.name,
          jobTitle: form.primaryContractor.jobTitle,
          email: form.primaryContractor.email,
          phone: form.primaryContractor.phone  
        },
        presetTags: this.distinct(form.presetTags).join(','),
        sendSurveyDay: form.sendSurveyDay || 1
      }
      return request;
    },
    updateProject(){
      let request = this.buildRequest(this.form);

      this.sending = true;      
      axios
        .post(`${this.$api_url}/projects/update`, request, this.getReqConfig())
        .then(() => {
          this.$emit("submit");
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        });
    },
    addProject() {
      let request = this.buildRequest(this.form);
      this.sending = true;
      axios
        .post(`${this.$api_url}/projects/add`, request, this.getReqConfig())
        .then(() => {
          this.$emit('submit', request.projectId);
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        })
    },
    validateProject(form) {
      const initErrors = this.errors.length;
      if (!form.name) {
        this.errors.push({ message: 'Name cannot be empty'});
      }
      if (!form.startDate) {
        this.errors.push({ message: 'Start Date cannot be empty'});
      }
      if (form.startDate && form.endDate && new Date(form.startDate) >= new Date(form.endDate)) {
        this.errors.push({ message: "End Date must be after Start Date"});
      }
      if (form.projectCost && isNaN(parseFloat(form.projectCost))) {
        this.errors.push({ message: 'Project Budget must be a number' });
      }
      if (form.partneringCost && isNaN(parseFloat(form.partneringCost))) {
        this.errors.push({ message: 'Partnering Cost must be a number' });
      }
      if (!form.owner.name) {
        this.errors.push({ message: 'Owner cannot be empty'});
      }
      if (!form.contractor.name) {
        this.errors.push({ message: 'Contractor cannot be empty'});
      }
      if (!form.primaryOwner.name) {
        this.errors.push({ message: 'Resident Engineer cannot be empty'});
      }
      if (!form.primaryContractor.name) {
        this.errors.push({ message: 'Project Manager cannot be empty'});
      }

      return this.errors.length === initErrors;
    },
    newForm() {
      return {
        name: "",
        primaryOwner: this.newUser(),
        primaryContractor: this.newUser(),
        startDate: "",
        endDate: "",
        projectCost: "",
        partneringCost: "",
        status: "",
        owner: this.newOrganization(),
        contractor: this.newOrganization(),
        uploadedCharter: "",
        district: "",
        projectIdentifier: "",
        charter: null,
        presetTags: [],
        sendSurveyDay: 1
      };
    },
    newOrganization() {
      return {
        organizationId: '',
        name: ''
      }
    },
    newUser() {
      return {
        id: '',
        name: '',
        jobTitle: '',
        email: '',
        phone: ''
      };
    },
    buildProject(project) {
      return {
        name: project.projectName,
        primaryOwner: project.primaryOwner != null ? this.buildUser(project.primaryOwner): "",
        primaryContractor: project.primaryContractor != null ? this.buildUser(project.primaryContractor): "",
        startDate: this.$helpers.APIStringToInput(project.startDate),
        endDate: this.$helpers.APIStringToInput(project.endDate),
        projectCost: project.projectCost,
        partneringCost: project.partneringCost,
        status: project.status,
        owner: project.ownerOrganization,
        contractor: project.contractorOrganization, 
        uploadedCharter: "",
        district: project.category,
        projectIdentifier: project.projectIdentifier,
        charter: null,
        presetTags: project.presetTags,
        sendSurveyDay: project.sendSurveyDay || 1
      }
    },
    buildUser(user) {
      return {
        id: user.userId,
        name: user.name,
        jobTitle: user.jobTitle,
        email: user.email,
        phone: user.phone
      };
    },
    addUserSubmit(user) {
      if (this.addingUser === "Owner") {
        this.form.primaryOwner = {
          id: user.userId,
          name: user.name,
          jobTitle: user.jobTitle,
          email: user.email,
          phone: user.phone
        };
        this.addedNewPrimaryOwner = true;
      } else if (this.addingUser === "Contractor") {
        this.form.primaryContractor = {
          id: user.userId,
          name: user.name,
          jobTitle: user.jobTitle,
          email: user.email,
          phone: user.phone
        };
        this.addedNewPrimaryContractor = true;
      }
      this.addingUser = "";
    },
    addPrimaryOwner() {
      this.addingUser = "Owner";
      this.$refs['new-user-modal'].show();
    },
    addPrimaryContractor() {
      this.addingUser = "Contractor";
      this.$refs['new-user-modal'].show();
    },
    addOrganizationSubmit(organization) {
      if (this.addingOrganization === "Owner") {
        this.form.owner = organization;
        if (this.organizationExists(organization)) {
          this.loadOwnerUsers()
        } else {
          this.addedNewOwner = true;
        }
      } else if (this.addingOrganization === "Contractor") {
        this.form.contractor = organization;
        if (this.organizationExists(organization)) {
          this.loadContractorUsers();
        } else {
          this.addedNewContractor = true;
        }
      }
      this.addingOrganization = "";
    },
    addOwner() {
      this.addingOrganization = "Owner";
      this.$refs['new-organization-modal'].show();
    },
    addContractor() {
      this.addingOrganization = "Contractor";
      this.$refs['new-organization-modal'].show();
    },
    onContractorChange() {
      //Check if blank
      this.form.primaryContractor = this.newUser();

      this.contractorUserOptions = [{ value: this.newUser(), text: "" }];
      if (this.form.contractor.organizationId !== "") {
        //A more efficient way to do this is to store the organizations' user
        this.loadContractorUsers();
      }
    },
    onOwnerChange() {
      //Check if blank
      this.form.primaryOwner = this.newUser();

      this.ownerUserOptions = [{ value: this.newUser(), text: "" }];
      if (this.form.owner.organizationId !== "") {
        //A more efficient way to do this is to store the organizations' user
        this.loadOwnerUsers();
      }
    },
    loadOrganizations() {
      this.loadingOrgs = true;
      axios
        .get(`${this.$api_url}/organizations`, this.getReqConfig())
        .then(response => {
          this.organizations = response.data;
          this.organizations
            .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
          this.orgOptions = [{ value: this.newOrganization(), text: "" }];
          this.orgOptions.push(
            ...this.organizations.map(o => ({
              value: o,
              text: o.name
            }))
          );
          if (this.mode === "Edit" && this.project != null) {

            try {
              let ownerOption = this.orgOptions
                .find(o => o.value.organizationId === this.project.ownerOrganization.organizationId);
              ownerOption.text += " (CURRENT)";
            } catch (err) {
              console.log(err);
            }
            try {
              let contractorOption = this.orgOptions
                .find(o => o.value.organizationId === this.project.contractorOrganization.organizationId);
              contractorOption.text += " (CURRENT)";
            } catch (err) {
              console.log(err);
            }

            this.loadOwnerUsers();
            this.loadContractorUsers();
          }
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingOrgs = false;
        });
    },
    loadContractorUsers() {
      this.loadingContractorUsers = true;
      axios
        .get(`${this.$api_url}/organizations/${this.form.contractor.organizationId}/users`,
          this.getReqConfig())
        .then(response => {
          this.contractorUserOptions.push(
            ...response.data.map(u => ({ value: this.buildUser(u), text: u.name }))
          );
          this.contractorUserOptions
            .sort((a, b) => a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1);
          if (this.mode === "Edit" && this.project != null) {
            try {
              let contractorOption = this.contractorUserOptions
                .find(o => o.value.id === this.project.primaryContractor.userId);
              this.form.primaryContractor = contractorOption.value;
              contractorOption.text += " (CURRENT)";
            } catch (err) {
              console.log(err);
            }
          }
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingContractorUsers = false;
        });
    },
    loadOwnerUsers() {
      this.loadingOwnerUsers = true;
      axios
        .get(`${this.$api_url}/organizations/${this.form.owner.organizationId}/users`,
          this.getReqConfig())
        .then(response => {
          this.ownerUserOptions.push(
            ...response.data.map(u => ({ value: this.buildUser(u), text: u.name }))
          );
          this.ownerUserOptions
            .sort((a, b) => a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1);
          if (this.mode === "Edit" && this.project != null) {
            try {
              let ownerOption = this.ownerUserOptions
                .find(o => o.value.id === this.project.primaryOwner.userId);
              this.form.primaryOwner = ownerOption.value;
              ownerOption.text += " (CURRENT)";
            } catch (err) {
              console.log(err);
            }
          }
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingOwnerUsers = false;
        });
    },
    organizationExists(org) {
      return this.organizations.some(o => o.name === org.name);
    },
    distinct(values) {
      return [...new Set(values)];
    },
    hasField(field) {
      return this.fields.includes(field);
    }
  },
  computed: {
    contractorUserValidOptions() {
      return this.addedNewPrimaryContractor
        ? [{ value: this.form.primaryContractor, text: this.form.primaryContractor.name }]
        : this.contractorUserOptions.filter(o => o.text === '' ||
          o.value.id !== this.form.primaryOwner.id);
    },
    ownerUserValidOptions() {
      return this.addedNewPrimaryOwner
        ? [{ value: this.form.primaryOwner, text: this.form.primaryOwner.name }]
        : this.ownerUserOptions.filter(o => o.text === '' ||
          o.value.id !== this.form.primaryContractor.id);
    },
    ownerOptions() {
      return this.addedNewOwner
        ? [{ value: this.form.owner, text: this.form.owner.name }]
        : this.orgOptions.filter(o => o.value.organizationId === '' ||
          o.value.organizationId !== this.form.contractor.organizationId);
    },
    contractorOptions() {
      return this.addedNewContractor
        ? [{ value: this.form.contractor, text: this.form.contractor.name }]
        : this.orgOptions.filter(o => o.value.organizationId === '' ||
          o.value.organizationId !== this.form.owner.organizationId);
    },
    projectCostState() {
      return this.form.projectCost
        ? isNaN(parseFloat(this.form.projectCost)) 
          ? false
          : this.mode === "Add" ? true : null
        : null
    },
    partneringCostState() {
      return this.form.partneringCost
        ? isNaN(parseFloat(this.form.partneringCost)) 
          ? false 
          : this.mode === "Add" ? true : null 
        : null
    },
    userEmails() {
      if(this.form.primaryContractor.email == undefined && this.form.primaryOwner.email == undefined){
          return [];
      }else if(this.form.primaryContractor.email == undefined){
         return [this.form.primaryOwner.email]
        .map(u => u.email);

      }else if(this.form.primaryOwner.email == undefined){
         return [this.form.primaryContractor.email]
        .map(u => u.email);

      }else{
        return [this.form.primaryContractor.email]
        .concat([this.form.primaryOwner.email])
        .map(u => u.email);
      }
    },
    hasAllFields() {
      return this.fields.length === 0;
    }
  }
}
</script>